import React from 'react';
import { StudioPhoto, StudioPhotoStage } from '@core/models';
import { formatUtcDate } from '@utils/date.util';
import moment from 'moment';
import { Tag } from 'antd';

type Props = {
  studioPhoto: StudioPhoto;
};

export const getStatusData = (studioPhoto: StudioPhoto): StudioPhotoStage | string => {
  const todayTime = moment();
  const accessedAtTime = moment(studioPhoto.accessed_at).unix();
  const windowtime = todayTime.add('months', 2).unix();
  const isInWindow = windowtime - accessedAtTime > 0;
  switch (true) {
    case studioPhoto.is_live:
      return StudioPhotoStage.Published;
    case !!studioPhoto.accessed_at && isInWindow:
      return `Accessed at ${formatUtcDate(studioPhoto.accessed_at || '')}`;
    case !!studioPhoto.publish_at:
      return StudioPhotoStage.Scheduled;
    case studioPhoto.labels.length > 0 && studioPhoto.description.length > 0:
      return StudioPhotoStage.Queued;
    default:
      return StudioPhotoStage.Processing;
  }
};

const RenderStudioPhotoStatus = ({ studioPhoto }: Props) => {
  return <Tag color="orange">{getStatusData(studioPhoto)}</Tag>;
};

export default RenderStudioPhotoStatus;
